import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
  Spinner,
  Select,
  Icon,
  Tabs,
  TabList,
  Tab,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaCircle, FaPlus, FaAlignJustify } from "react-icons/fa";
import { HamburgerIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import moment from "moment";
import ListaBoletoAPI from "../../../services/ListaBoleto";
import SystemApi from "../../../services/systemApi";
import ExtratoApi from "../../../services/ExtratoAPI";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { componentState } from "../../../atoms/componentState";
import { LoggedUser } from "../../../atoms/userLogged";
import { customColors } from "../../../atoms/customColors";
import { permissions } from "../../../atoms/permissions";
import Pagination from "../../../defaultComponents/pagination";
import DateDropdownDeafult from "../../../defaultComponents/dateDropdown";
import ModalDetailVendaBoleto from "./components/ModalDetailVendaBoleto";
import {
  goToAddVendaBolePix,
  goToAddVendaBolePixLote,
} from "../../../routes/coordinator";

interface objetoSalesList {
  id: string;
  idCliente: number;
  bandeira: string;
  clienteNome: string | null;
  cnpj: string;
  dataCriacao: string;
  dataExpiracao: string | null;
  dataPagamento: string | null;
  isCnpj: boolean;
  nomeFantasia: string;
  razaoSocial: string;
  status: string;
  taxaCliente: number;
  taxaPlano: number;
  valor: number;
  valorLiquido: number;
  barcode?: string;
  emv?: string;
  mensagem?: string;
}

interface statusInfo {
  id: number;
  status: string;
}

interface basicInfo {
  id: number;
  nome: string;
}

interface JWTToken {
  primarysid: string;
  name: string;
  email: string;
  exp: number;
  idCliente: number;
  loginPermissoes: string;
}

export default function SalesListBolePix() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState<objetoSalesList[]>([]);
  const [openDetails, setOpenDetails] = useState(false);
  const [details, setDetails] = useState<objetoSalesList | {}>({});
  const [statusList, setStatusList] = useState<statusInfo[]>([]);
  const [modoPgtoList, setModoPgtoList] = useState<basicInfo[]>([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [permissionsList, setPermissionsList] = useState<Array<any>>([]);
  const [isNotEmpty, setIsNotEmpty] = useState(false);

  const [colors] = useRecoilState(customColors);
  const [user] = useRecoilState(LoggedUser);
  const setPermsRecoil = useSetRecoilState(permissions);
  const token = window.localStorage.getItem("token");
  const jwtToken: JWTToken = jwt_decode(token || "");
  const navigate = useNavigate();
  const setHeaderLocation = useSetRecoilState(componentState);

  const initialValues = {
    statusFilter: 0,
    saleTypeFilter: 5,
    initialDateFilter: "2025-07-01T00:00:00",
    finalDateFilter: "2025-07-31T23:59:59",
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);

  let loginPermissoes: number[] = [];
  if (token && typeof token === "string" && token.includes(".")) {
    try {
      const decoded: JWTToken = jwt_decode(token);
      if (decoded.loginPermissoes) {
        loginPermissoes = JSON.parse(decoded.loginPermissoes);
      }
    } catch (error) {
      console.error("Error decoding JWT or parsing loginPermissoes:", error);
    }
  }

  async function getBolepix(isBatch: boolean = false) {
    try {
      setLoading(true);
      const response = await ListaBoletoAPI.getBolepix(
        currentPage,
        pageSize,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        search,
        Number(jwtToken.idCliente),
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.statusFilter,
        filtros.saleTypeFilter
      );

      const mappedData: objetoSalesList[] = response.data
        .filter(
          (item: any) =>
            item.transacao && (isBatch ? item.idLote : !item.idLote)
        )
        .map((item: any) => ({
          id: item.id,
          idCliente: item.idCliente,
          bandeira: item.transacao.bandeira || "N/A",
          clienteNome: item.transacao.clienteNome || "N/A",
          cnpj: item.transacao.cnpj || "N/A",
          dataCriacao: item.transacao.dataCriacao || item.criadoEm,
          dataExpiracao: item.transacao.dataExpiracao || item.dataVencimento,
          dataPagamento: item.transacao.dataPagamento || null,
          isCnpj: item.transacao.isCnpj || false,
          nomeFantasia: item.transacao.nomeFantasia || "N/A",
          razaoSocial: item.transacao.razaoSocial || "N/A",
          status: item.transacao.status || "unknown",
          taxaCliente: item.transacao.taxaCliente || 0,
          taxaPlano: item.transacao.taxaPlano || 0,
          valor:
            item.transacao.valor ||
            parseFloat(item.valor.replace(",", ".")) ||
            0,
          valorLiquido: item.transacao.valorLiquido || 0,
          barcode: item.barcode || "N/A",
          emv: item.emv || "N/A",
          mensagem: item.mensagem || "N/A",
        }));

      setSalesList(mappedData);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching sales list:", error);
      toast.error("Erro ao carregar a lista de vendas!");
    }
  }

  async function exportReport() {
    try {
      setLoading(true);
      const response = await ExtratoApi.exportFile(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        Number(jwtToken.idCliente),
        "",
        filtros.saleTypeFilter,
        filtros.statusFilter
      );
      fileDownload(response, "relatorio.xlsx");
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
      setLoading(false);
    }
  }

  async function getStatusList() {
    try {
      const response = await SystemApi.getTransacoesStatus();
      setStatusList(response);
    } catch (error) {
      console.error("Error fetching status list:", error);
    }
  }

  async function getModoPgtoList() {
    try {
      const response = await SystemApi.getTransacoesModoPagamento();
      setModoPgtoList(response);
    } catch (error) {
      console.error("Error fetching payment methods:", error);
    }
  }

  useEffect(() => {
    setHeaderLocation("Lista de Vendas");
    getStatusList();
    getModoPgtoList();
  }, []);

  useEffect(() => {
    getBolepix(tabIndex === 1);
  }, [
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
    tabIndex,
  ]);

  const statusOptions = statusList.map((item) => ({
    key: item.id,
    value: item.id,
    text: item.status,
  }));

  const modoPgtoOptions = modoPgtoList.map((item) => ({
    key: item.id,
    value: item.id,
    text: item.nome,
  }));

  const onChangeStatusFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
    setCurrentPage(1);
  };

  const onChangeModoPgtoFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFiltros({ ...filtros, saleTypeFilter: Number(e.target.value) });
    setCurrentPage(1);
  };

  const onChangeSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "succeeded":
        return colors.GREENMONEDD;
      case "pending":
        return colors.YELLOWMONEDD;
      case "failed":
        return colors.ORANGEMONEDD;
      case "new":
        return colors.GRAYCARD;
      case "chargeback":
        return colors.REDCARD;
      case "canceled":
        return colors.REDMONEDD;
      default:
        return colors.GRAY;
    }
  };

  const renderTable = () => (
    <TableContainer
      maxWidth="100%"
      overflowX="auto"
      overflowY="auto"
      maxHeight="55vh"
    >
      <Table
        variant="simple"
        size="md"
        colorScheme="gray"
        width="100%"
        minWidth="1400px"
      >
        <Thead>
          <Tr>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              borderTopLeftRadius="md"
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Data
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="150px"
              whiteSpace="nowrap"
            >
              EC
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Status
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Vencimento
            </Th>
            {/*   <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Data de Criação
            </Th> */}
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="100px"
              whiteSpace="nowrap"
            >
              Valor Total
            </Th>
            {/*      <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="80px"
              whiteSpace="nowrap"
            >
              %Taxa
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="100px"
              whiteSpace="nowrap"
            >
              Valor Tarifa
            </Th> */}
            {/*     <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="100px"
              whiteSpace="nowrap"
            >
              Valor Líquido
            </Th> */}
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              borderTopRightRadius="md"
              minWidth="80px"
              whiteSpace="nowrap"
              position="sticky"
              right={0}
              zIndex={1}
              bg={colors.BLUEMONEDDBACKGROUND}
            >
              Opções
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {salesList.length === 0 ? (
            <Tr>
              <Td colSpan={11} textAlign="center">
                Nenhuma venda encontrada
              </Td>
            </Tr>
          ) : (
            salesList.map((item, index) => (
              <Tr
                key={index}
                _hover={{ bg: colors.GRAY_LIGHTEST }}
                transition="background 0.2s"
              >
                <Td whiteSpace="nowrap">
                  {item.dataCriacao
                    ? moment(item.dataCriacao).format("DD/MM/YYYY HH:mm")
                    : "- -"}
                </Td>
                <Td whiteSpace="nowrap">
                  {item.isCnpj
                    ? item.razaoSocial
                    : `${item.razaoSocial} ${item.nomeFantasia || ""}`}
                </Td>
                <Td whiteSpace="nowrap">
                  <Flex alignItems="center">
                    <Icon
                      as={FaCircle}
                      color={getStatusColor(item.status)}
                      boxSize={3}
                      mr={2}
                    />
                    {item.status === "succeeded" && "Sucesso"}
                    {item.status === "pending" && "Pendente"}
                    {item.status === "failed" && "Falhou"}
                    {item.status === "new" && "Nova"}
                    {item.status === "chargeback" && "ChargeBack"}
                    {item.status === "canceled" && "Cancelado"}
                    {item.status === "unknown" && "Desconhecido"}
                    {![
                      "succeeded",
                      "pending",
                      "failed",
                      "new",
                      "chargeback",
                      "canceled",
                      "unknown",
                    ].includes(item.status) && item.status}
                  </Flex>
                </Td>
                <Td whiteSpace="nowrap">
                  {item.dataExpiracao
                    ? moment(item.dataExpiracao).format("DD/MM/YYYY HH:mm")
                    : "- -"}
                </Td>
                {/*     <Td whiteSpace="nowrap">
                  {item.dataPagamento
                    ? moment(item.dataPagamento).format("DD/MM/YYYY")
                    : "- -"}
                </Td> */}
                <Td whiteSpace="nowrap">
                  {(item.valor ?? 0).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Td>
                {/*     <Td whiteSpace="nowrap">
                  {item.taxaPlano ? `${item.taxaPlano}%` : "0%"}
                </Td>
                <Td whiteSpace="nowrap">
                  {(item.taxaCliente ?? 0).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Td> */}
                {/*    <Td whiteSpace="nowrap">
                  {(item.valorLiquido ?? 0).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Td> */}
                <Td
                  whiteSpace="nowrap"
                  position="sticky"
                  right={0}
                  zIndex={1}
                  bg={colors.WHITE}
                >
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      aria-label="Options"
                      icon={<HamburgerIcon />}
                      bgColor={colors.BLUEMONEDDBUTTONS}
                      color={colors.WHITE}
                      size="sm"
                      _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
                      _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
                      transition="all 0.2s"
                    />
                    <MenuList>
                      <MenuItem
                        onClick={() => {
                          setOpenDetails(true);
                          setDetails(item);
                        }}
                        _hover={{ bg: colors.GRAY_LIGHT }}
                      >
                        Visualizar Detalhes
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );

  return (
    <Flex
      flexDir="column"
      height="=40vh" // Ensure the entire component fits within the viewport
      width="100%"
      bgColor={colors.GRAY_LIGHTEST}
      p={8}
      overflow="hidden" // Prevent the entire page from scrolling
    >
      <Box mb={8} bg={colors.WHITE} borderRadius="lg" boxShadow="md" p={6}>
        <Flex alignItems="center" mb={6}>
          <Icon
            as={FaPlus}
            color={colors.BLUEMONEDDBUTTONS}
            boxSize={6}
            mr={3}
          />
          <Text
            fontSize="3xl"
            fontWeight="bold"
            color={colors.BLUEMONEDDBACKGROUND}
          >
            Vendas Boleto/PIX
          </Text>
        </Flex>
        <Flex flexWrap="wrap" gap={4} alignItems="center">
          <Select
            placeholder="Filtrar por Status"
            maxW="250px"
            value={filtros.statusFilter}
            onChange={onChangeStatusFilter}
            bg={colors.WHITE}
            borderColor={colors.GRAY_LIGHTER}
            _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
            _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
          >
            {statusOptions.map((item) => (
              <option value={item.value} key={item.key}>
                {item.text}
              </option>
            ))}
          </Select>
          <Select
            placeholder="Filtrar por Tipo de Venda"
            maxW="250px"
            value={filtros.saleTypeFilter}
            onChange={onChangeModoPgtoFilter}
            bg={colors.WHITE}
            borderColor={colors.GRAY_LIGHTER}
            _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
            _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
          >
            {modoPgtoOptions.map((item) => (
              <option value={item.value} key={item.key}>
                {item.text}
              </option>
            ))}
          </Select>
          <DateDropdownDeafult filtros={filtros} setFiltros={setFiltros} />
          <Button
            bgColor={colors.GRAY_DARK}
            color={colors.WHITE}
            size="md"
            onClick={() => setFiltros(initialValues)}
            _hover={{ bgColor: colors.GRAY_DARKEST }}
            _active={{ bgColor: colors.GRAY_DARKER }}
            transition="all 0.2s"
          >
            Limpar Filtros
          </Button>

          <Button
            bgColor={colors.BLUEMONEDDBUTTONS}
            color={colors.WHITE}
            size="md"
            onClick={() => goToAddVendaBolePix(navigate)}
            leftIcon={<FaPlus />}
            _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
            _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
            transition="all 0.2s"
          >
            Nova Venda BOLEPIX / Individual
          </Button>

          <Button
            bgColor="transparent"
            color={colors.BLUEMONEDDBUTTONS}
            size="md"
            onClick={exportReport}
            isLoading={loading}
            leftIcon={<FaPlus />}
            _hover={{ color: colors.BLUEMONEDDRGB2 }}
            transition="all 0.2s"
          >
            Exportar Relatório
          </Button>
        </Flex>
      </Box>
      <Box
        flex="1"
        bg={colors.WHITE}
        borderRadius="lg"
        boxShadow="md"
        p={6}
        overflow="visible"
        maxHeight="calc(100vh - 300px)" // Adjust height to fit within viewport
      >
        <Tabs
          variant="unstyled"
          index={tabIndex}
          onChange={(index) => setTabIndex(index)}
        >
          <TabList
            mb={4}
            borderBottom="2px solid"
            borderColor={colors.GRAY_LIGHTER}
          >
            <Tab
              px={6}
              py={3}
              fontWeight="semibold"
              color={
                tabIndex === 0 ? colors.BLUEMONEDDBUTTONS : colors.GRAY_DARK
              }
              borderBottom={
                tabIndex === 0
                  ? `3px solid ${colors.BLUEMONEDDBUTTONS}`
                  : "none"
              }
              _hover={{ color: colors.BLUEMONEDDRGB2 }}
              _focus={{ outline: "none" }}
            >
              Individual
            </Tab>
            {/*         <Tab
              px={6}
              py={3}
              fontWeight="semibold"
              color={
                tabIndex === 1 ? colors.BLUEMONEDDBUTTONS : colors.GRAY_DARK
              }
              borderBottom={
                tabIndex === 1
                  ? `3px solid ${colors.BLUEMONEDDBUTTONS}`
                  : "none"
              }
              _hover={{ color: colors.BLUEMONEDDRGB2 }}
              _focus={{ outline: "none" }}
            >
              Lote
            </Tab> */}
          </TabList>
          <TabPanels>
            <TabPanel p={0}>
              {loading ? (
                <Flex h="50vh" alignItems="center" justifyContent="center">
                  <Spinner
                    size="xl"
                    color={colors.BLUEMONEDDBUTTONS}
                    thickness="4px"
                  />
                </Flex>
              ) : (
                renderTable()
              )}
            </TabPanel>
            <TabPanel p={0}>
              {loading ? (
                <Flex h="50vh" alignItems="center" justifyContent="center">
                  <Spinner
                    size="xl"
                    color={colors.BLUEMONEDDBUTTONS}
                    thickness="4px"
                  />
                </Flex>
              ) : (
                renderTable()
              )}
            </TabPanel>
          </TabPanels>
        </Tabs>
        <Flex justifyContent="center" alignItems="center" mt={6} gap={4}>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            pageSize={pageSize}
          />
          <Select
            value={pageSize}
            onChange={onChangeSize}
            size="sm"
            width="80px"
            bg={colors.WHITE}
            borderColor={colors.GRAY_LIGHTER}
            _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
            _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={25}>25</option>
          </Select>
        </Flex>
        <ModalDetailVendaBoleto
          isOpen={openDetails}
          setIsOpen={setOpenDetails}
          item={details}
        />
      </Box>
    </Flex>
  );
}
